/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * jeeves/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Why content search will not index one of a run's files.
More reasons may be added; treat a value you do not recognize as a file that
is not searchable for an unstated reason.

 - CONTENT_SKIP_REASON_UNSPECIFIED: Unspecified reason. Not returned by the server.
 - CONTENT_SKIP_REASON_NO_TEXT_LAYER: The file has no text layer, such as an image or a scanned PDF. Content
search does not run OCR.
 - CONTENT_SKIP_REASON_TOO_LARGE: The file is larger than content search reads. A file that is only cut off
at a limit is indexed instead, and counted in
RunContentCoverage.partially_indexed_file_count.
 - CONTENT_SKIP_REASON_UNSUPPORTED_FORMAT: Content search cannot read the file's format, such as a legacy Word or
PowerPoint document, an Outlook message, or an archive.
 - CONTENT_SKIP_REASON_ENCRYPTED: The file is password-protected.
 - CONTENT_SKIP_REASON_FAILED: Reading the file failed and will not be retried, for example because the
file is corrupt, or reading it kept crashing or timing out.
 - CONTENT_SKIP_REASON_TOO_MANY_FILES: The run has more files than content search indexes for a single run, and
this file is beyond that limit.
 - CONTENT_SKIP_REASON_INACCESSIBLE: The file cannot be read from this run: it no longer exists, or the run
refers to it somewhere content search does not follow, such as another
workspace.
 */
export type V1ContentSkipReason =
  (typeof V1ContentSkipReason)[keyof typeof V1ContentSkipReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1ContentSkipReason = {
  CONTENT_SKIP_REASON_UNSPECIFIED: 'CONTENT_SKIP_REASON_UNSPECIFIED',
  CONTENT_SKIP_REASON_NO_TEXT_LAYER: 'CONTENT_SKIP_REASON_NO_TEXT_LAYER',
  CONTENT_SKIP_REASON_TOO_LARGE: 'CONTENT_SKIP_REASON_TOO_LARGE',
  CONTENT_SKIP_REASON_UNSUPPORTED_FORMAT:
    'CONTENT_SKIP_REASON_UNSUPPORTED_FORMAT',
  CONTENT_SKIP_REASON_ENCRYPTED: 'CONTENT_SKIP_REASON_ENCRYPTED',
  CONTENT_SKIP_REASON_FAILED: 'CONTENT_SKIP_REASON_FAILED',
  CONTENT_SKIP_REASON_TOO_MANY_FILES: 'CONTENT_SKIP_REASON_TOO_MANY_FILES',
  CONTENT_SKIP_REASON_INACCESSIBLE: 'CONTENT_SKIP_REASON_INACCESSIBLE',
} as const;
